function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { useCallback, useEffect, useRef, useState } from "react";
export function useSectionNavigation(ref, querySelector) {
    var _$ref = _slicedToArray(useState(0), 2), activeIndex = _$ref[0], setActiveIndex = _$ref[1];
    var _$ref1 = _slicedToArray(useState([]), 2), elements = _$ref1[0], setElements = _$ref1[1];
    var _$ref2 = _slicedToArray(useState([]), 2), intersections = _$ref2[0], setIntersections = _$ref2[1];
    var handleRootIntersect = useCallback(function(entries) {
        if (entries[0].isIntersecting) {
            var _$ref;
            var _$ref1;
            var next = Array.from((_$ref1 = (_$ref = ref.current) === null || _$ref === void 0 ? void 0 : _$ref.querySelectorAll(querySelector)) !== null && _$ref1 !== void 0 ? _$ref1 : []);
            setElements(next);
            var _index;
            setIntersections(next.map(function(el, index) {
                return (_index = intersections[index]) !== null && _index !== void 0 ? _index : 0;
            }));
        }
    }, []);
    var rootIntersectionObserverRef = useRef(typeof window !== "undefined" ? new IntersectionObserver(handleRootIntersect, {
        threshold: 0
    }) : undefined);
    if (ref.current) {
        var _$ref3;
        (_$ref3 = rootIntersectionObserverRef.current) === null || _$ref3 === void 0 ? void 0 : _$ref3.observe(ref.current);
    }
    useEffect(function() {
        var intersectionObserver = typeof IntersectionObserver !== "undefined" ? new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var index = elements.indexOf(entry.target);
                intersections[index] = entry.intersectionRatio;
            });
            setIntersections(_toConsumableArray(intersections));
        }, {
            threshold: 1.0
        }) : null;
        elements === null || elements === void 0 ? void 0 : elements.forEach(function(el) {
            if (_instanceof(el, HTMLElement)) {
                intersectionObserver === null || intersectionObserver === void 0 ? void 0 : intersectionObserver.observe(el);
            }
        });
        return function() {
            intersectionObserver === null || intersectionObserver === void 0 ? void 0 : intersectionObserver.disconnect();
        };
    }, [
        elements
    ]);
    useEffect(function() {
        for(var i = 0; i < intersections.length; i += 1){
            if (intersections[i] === 1) {
                setActiveIndex(i);
                break;
            }
        }
    }, [
        intersections
    ]);
    return activeIndex;
}

//# sourceMappingURL=useSectionNavigation.js.map